import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "customHtml",
  meta: {},
  props: {
    content: {
      prop: "other",
      type: "custom-html",
      value: {
        head: `<!-- Add <head> content here like:
  - <link> tags for external CSS
  - <style> tags for custom CSS
  - <script> tags for JavaScript -->`,
        body: `<!-- Add <body> content here like:
  - HTML elements (<div>, <p>, etc.)
  - Embedded content and widgets -->`,
      },
      meta: {
        name: "Code",
        nameI18n: "builder_ui.prop_type.code",
      },
    },
  },
};
